import { useMemo } from "react";

import { useCheckboxesSchema } from "./useCheckboxesSchema";
import { RADIOS } from "../SchemaTypes";
import RadioButtonsInput from "../../Input/RadioButtonsInput";
import Field, {
  FIELD_MODE_FIELDSET,
  FIELD_MODE_LABEL,
  FIELD_MODE_NO_FIELD
} from "../Field";
import { useParsedFieldProps } from "./useParsedFieldProps";

const RadioButtonsField = props => {
  const { fieldProps, inputProps } = useParsedFieldProps(props);
  const { required, parent, isCorrection, displayOtherField, options, defaultValues } =
    props;

  const defaultValue = defaultValues[0];

  const schema = useCheckboxesSchema({
    type: RADIOS,
    singleOptionSelection: true,
    required,
    parent
  });

  const fieldMode = useMemo(() => {
    if (isCorrection) {
      return FIELD_MODE_NO_FIELD;
    } else if (options.length > 1 || displayOtherField) {
      return FIELD_MODE_FIELDSET;
    } else {
      return FIELD_MODE_LABEL;
    }
  }, [displayOtherField, isCorrection, options.length]);

  return (
    <Field {...fieldProps} schema={schema} fieldMode={fieldMode}>
      <RadioButtonsInput {...inputProps} defaultValue={defaultValue} />
    </Field>
  );
};

export default RadioButtonsField;
